import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";
import Axios from 'axios'
import apiConfig from '../config/api'

interface ICredentials {
    email: string;
    password: string;
}

interface IState {
    user: {};
    status: string;
}

export const signIn = createAsyncThunk('user/signIn', async (credentials: ICredentials) => {
    // ASync operation
    const result = await Axios.post(`${apiConfig.domain}/api/login`, {
        user: credentials
    })
    console.log(result)

    return result.data
})

const initialState = {
    user: {},
    status: "",
} as IState


const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        logOut: (state) => {
            state.status = "";
            state.user = {};
        },
    },
    extraReducers: (builder) => {
        builder.addCase(signIn.pending, (state) => {
            state.status = 'loading'
        })
        builder.addCase(signIn.fulfilled, (state, action) => {
            state.user = action.payload
            state.status = 'success'
        })
        builder.addCase(signIn.rejected, (state) => {
            state.status = 'failed'
        })
    },
})

export const {
    logOut
} = userSlice.actions;

export default userSlice.reducer;